module.exports = __webpack_public_path__ + "static/media/slider-2.6992aa46.jpg";